module.exports = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/plugins/gritter/images/ie-spacer.gif
// module id = 1175
// module chunks = 86